import React, { useState, useMemo, useEffect } from "react";
import { BsArrowDown } from "react-icons/bs";
import { EditorState, Modifier } from "draft-js";
import { Editor } from "react-draft-wysiwyg";
import Picker from "@emoji-mart/react";
import data from "@emoji-mart/data";
import documentUploadBig from "../../../assets/icons/document-upload-big.svg";
import documentUploadSmall from "../../../assets/icons/document-upload-small.svg";
import BoldIcon from "../../../assets/icons/Bold.svg";
import xCircle from "../../../assets/icons/x-circle.svg";
import ItalicIcon from "../../../assets/icons/italic.svg";
import UnderlineIcon from "../../../assets/icons/underline.svg";
import emojiIcon from "../../../assets/icons/smileSMS.svg";
import attachIcon from "../../../assets/icons/attach_fileSMS.svg";
import smsSendIcon from "../../../assets/icons/sendSMSIcon.svg";
import DocumentUploaderWithProgress from "../../Common/Document_Uploader_With_Progress";

const DocumentAttachedModal = ({
  setIsAttached,
  setAttachmentUrl,
  setSearchStat,
  setSearchText,
  textAreaRef,
  val,
  setVal,
  placeholder,
  handleKeyDown,
  editorState,
  setEditorState,
  attachedName,
  attachedSize,
  attachedUrl,
  showDownArrow,
  scrollToBottom,
  mentionUsers,
  onFileUploaded,
  setShowEmojiPicker,
  showEmojiPicker,
  setAttachedName,
  setAttachedSize,
  sendMessage,
}) => {
  const [activeAttachment, setActiveAttachment] = useState([0]);
  const extension = attachedUrl[activeAttachment].split(".").pop().toLowerCase();

  const isImage = ["jpg", "jpeg", "png", "webp", "gif"].includes(extension);

  const handleRemoveAttachment = () => {
    setIsAttached(false);
    setAttachmentUrl("");
    setAttachedName("");
    setAttachedSize("");
  };

  const handleEmojiSelect = (e) => {
    const contentState = Modifier.replaceText(
      editorState.getCurrentContent(),
      editorState.getSelection(),
      e.native,
      editorState.getCurrentInlineStyle()
    );
    setEditorState(EditorState.push(editorState, contentState, "insert-characters"));
  };

  return (
    <div className="attached-section">
      <div className="attached-information">
        Filename {attachedName[activeAttachment]}
        <div className="close-attached">
          <img
            src={xCircle}
            width={20}
            height={20}
            alt="Remove attachment"
            onClick={handleRemoveAttachment}
            className="m-2 cursor-pointer"
          />
        </div>
      </div>
      <div className="attached-icon-with-info">
        <div className="attached-icon-sec">
          <img
            src={isImage ? attachedUrl[activeAttachment] : documentUploadBig}
            width={isImage ? "100%" : 100}
            height={isImage ? 250 : 100}
            alt="Upload"
            onClick={() => {
              setSearchText("");
              setSearchStat(false);
            }}
            style={{ objectFit: "contain" }}
            className="m-2"
          />
          <h3 className="upload-size-doc">{attachedSize[activeAttachment]}</h3>
        </div>
      </div>

      <div className="write-message-block-div m-2">
        {showDownArrow && (
          <div className="chat-scroll-bottom" onClick={scrollToBottom}>
            <BsArrowDown color="#707070" />
          </div>
        )}
        <textarea
          ref={textAreaRef}
          value={val}
          onChange={(e) => setVal(e.target.value)}
          className="write-message d-none"
          placeholder={placeholder}
          onKeyDown={handleKeyDown}
        />
        <div
          className="p- col-1-1"
          id="chatComntBox"
          // style={{ height: "105px" }}
        >
          <Editor
            placeholder={placeholder}
            editorState={editorState}
            onEditorStateChange={setEditorState}
            wrapperClassName="wrapper-class"
            editorClassName="write-message"
            toolbarClassName="toolbar-bottom-absolute"
            toolbar={{
              options: ["inline"],
              inline: {
                options: ["bold", "italic", "underline"],
                bold: { icon: BoldIcon },
                italic: { icon: ItalicIcon },
                underline: { icon: UnderlineIcon },
              },
            }}
            mention={{
              separator: " ",
              trigger: "@",
              suggestions: mentionUsers,
            }}
            keyBindingFn={handleKeyDown}
          />
        </div>
        <div className="write-message-block">
          <div className="d-flex gap-3"></div>
          <div className="d-flex gap-3">
            <DocumentUploaderWithProgress onUploaded={onFileUploaded} maxSizeInMb={100}>
              <img src={attachIcon} style={{ cursor: "pointer", width: "15px", height: "15px" }} />
            </DocumentUploaderWithProgress>
            <div style={{ position: "relative" }}>
              <img
                src={emojiIcon}
                style={{ cursor: "pointer", width: "15px", height: "15px" }}
                onClick={() => setShowEmojiPicker(!showEmojiPicker)}
              />
              {showEmojiPicker && (
                <div className="emoji-picker-style">
                  <Picker data={data} onEmojiSelect={handleEmojiSelect} />
                </div>
              )}
            </div>
            <div>
              <img
                src={smsSendIcon}
                style={{ cursor: "pointer", width: "17px", height: "17px" }}
                onClick={sendMessage}
              />
            </div>
          </div>
        </div>
      </div>
      <div className="attached-icon-list">
        {attachedName?.map((_, index) => {
          const extension = attachedUrl[index].split(".").pop().toLowerCase();
          const isImage = ["jpg", "jpeg", "png", "webp", "gif"].includes(extension);
          return (
            <div
              className="attached-icon-inside current-uploaded"
              key={index}
              onClick={() => setActiveAttachment(index)}
              style={{ padding: isImage ? 0 : "10px", overflow: "hidden" }}
            >
              <div className="remove-current-uploaded">
                <img
                  src={xCircle}
                  width={15}
                  height={15}
                  alt="Remove"
                  onClick={handleRemoveAttachment}
                  className="m-2 cursor-pointer"
                />
              </div>
              <img
                src={isImage ? attachedUrl[index] : documentUploadSmall}
                width={isImage ? "100%" : 30}
                height={isImage ? "100%" : 30}
                alt="Upload"
                className="m-2"
                style={{ objectFit: isImage ? "cover" : "contain" }}
              />
            </div>
          );
        })}
        <DocumentUploaderWithProgress onUploaded={onFileUploaded} maxSizeInMb={100}>
          <div className="attached-icon-inside attached-more-icon">
            <img
              src={xCircle}
              width={30}
              height={30}
              alt="Upload more"
              className="m-2 cursor-pointer"
            />
          </div>
        </DocumentUploaderWithProgress>
      </div>
    </div>
  );
};

export default DocumentAttachedModal;
